// Shares of a whole have an immediately meaningful pie; measured values retain a trend.
export function defaultMetricChartType(row) {
  return row?.valueType==='percent'&&!row?.studioView?'pie':'line';
}
